import validate from "/usr/src/app/content/n3-spas-09910ce9-912a-45f0-bb37-4b89724ca635/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-spas-09910ce9-912a-45f0-bb37-4b89724ca635/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}